import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { number, string } from 'prop-types';
import React from 'react';

const Line = ({ percent, color = null }) => {
  const theme = useTheme();
  const backgroundColor = color || theme.palette.primary.main;

  return (
    <Box
      sx={{
        height: 10,
        backgroundColor,
        flexBasis: `${percent}%`,
      }}
    />
  );
};

Line.propTypes = {
  percent: number.isRequired,
  color: string,
};

export default Line;
